<script>
export default {
  name: "TaskStatistics.vue",
  data(){
    return{
      duration:0
    }
  },
  props:{
    isOpen:Boolean,
    task:Object,
  },
  methods:{
    closeWindow(){
      this.$emit('close-window')
    },
    editTask(){
      this.$emit('edit-task')
    },

  }
}
</script>

<template>
  <div class="statistics-container">
    <div class="statistics" :class="isOpen?'active':'hidden'">
      <div class="image-container">
        <img src="@/assets/close.svg" @click="closeWindow" alt="Close" width="24" height="24"/>
      </div>
      <h4 class="statistics-title">Прогноз статистики</h4>
      <div class="statistics-form">
        <div class="statistics-item">
          <span>Название задачи</span>
          <span class="statistics-item__info" v-if="task !==null">{{ task.taskName }}</span>
          <!--        {{task.taskName}}-->
        </div>
        <div class="statistics-item">
          <span>Тип задачи</span>
          <span v-if="task !==null" class="statistics-item__info">{{ task.label }}</span>
        </div>
        <!-- <div class="statistics-item">
          <span>Воспроизведение за день/span>
          <input :value="task.durationPlaylist" readonly>
        </div> -->
        <div class="statistics-item">
          <span>Воспроизведение за день</span>
          <span class="statistics-item__info">{{ task.durationTask }}</span>
        </div>
        <button @click="editTask" class="edit-button">Редактировать</button>
      </div>
    </div>
  </div>

</template>

<style scoped>

.active{
  display: block;
  transition: all 5s ease-in-out;
}
.hidden{
  display: none;
}
.statistics-container{
  position:fixed;
  top:30%;
  display: flex;
  flex-direction: column;
}
.statistics{
  padding-top:20px;
  padding-left:10px;
  padding-right:10px;
  padding-bottom:20px;
  transition: all 0.2s ease;
  border: 1px solid gray;
  border-radius: 12px;
  display: flex;
  align-self: center;
  position:static;
  top:50%;
  flex-direction: column;
  width:240px;
  height: 60%;
  margin-right:15px;
}
.statistics-title{
  text-align: center;
}
.statistics-form{
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  row-gap:30px;
  padding: 0px 10px;
  margin-top:20px;
}
.statistics-item{
  display: flex;
  flex-direction: column;
}
.statistics-item__info{
  text-align: left;
  margin-top: 8px;
  font-weight: 600;
  padding-bottom: 10px;
  border-bottom: 1px dashed black;
}
.image-container{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.edit-button{
  color: #fff;
  background-color: #0d6efd;
  border-color: #0d6efd;
  border: 1px solid transparent;
  border-radius:0.25rem;
  cursor:pointer;
  padding: .375rem .75rem;
  font-size:1rem;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.edit-button:hover{
  background-color: #aad2fc;
}
</style>